import './styles/tailwind.css';
const activeEnv = process.env.STAGE_ENV || 'development';

require('dotenv').config({
  path: `.env.${activeEnv}`,
});
export * from './types';
export * from './utils/AdapterSetup';
export * from './utils/IntermixBus';
export * from './components/layout';
export * from './components/core';
export * from './components/renderers';
export * from './components/hoc';
export * from './components/widgets';
